import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { get } from '../http';
import { activeSnack } from './common';

// --- API THUNKS START ---
export const getApp = createAsyncThunk('app/list', async ({ dispatch }) => {
  try {
    const response = await get(`/admin/app`);
    if (response.isSuccess) {
      return response?.app;
    }
    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(
      activeSnack({
        type: 'error',
        message: error?.response?.data?.message || 'something went wrong',
      })
    );
    throw error?.response?.data?.message;
  }
});

export const getDashboardData = createAsyncThunk(
  'static/dashboard/data',
  async ({ enqueueSnackbar, dates }) => {
    try {
      const response = await get(
        `/analytics/advertiser/summary?from=${dates?.from || ''}&to=${dates?.to || ''}`
      );
      return response;
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      throw error?.response?.data?.message;
    }
  }
);

export const getDashboardDataPerformance = createAsyncThunk(
  'static/dashboard/ppcPerformance',
  async ({ enqueueSnackbar, dates }) => {
    try {
      const response = await get(
        `analytics/advertiser/ppc-performance?from=${dates?.from || ''}&to=${dates?.to || ''}`
      );
      return response;
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      throw error?.response?.data?.message;
    }
  }
);

export const getDashboardDataHighestAcos = createAsyncThunk(
  'static/dashboard/highestAcos',
  async ({ enqueueSnackbar, dates }) => {
    try {
      const response = await get(
        `analytics/advertiser/highest-acos?from=${dates?.from || ''}&to=${dates?.to || ''}`
      );
      return response;
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      throw error?.response?.data?.message;
    }
  }
);

export const getDashboardDataHighestSpend = createAsyncThunk(
  'static/dashboard/highestSpend',
  async ({ enqueueSnackbar, dates }) => {
    try {
      const response = await get(
        `analytics/advertiser/highest-spend?from=${dates?.from || ''}&to=${dates?.to || ''}`
      );
      return response;
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      throw error?.response?.data?.message;
    }
  }
);
// --- REDUX SLICE START ---
export const appSlice = createSlice({
  name: 'app',
  initialState: {
    loading: false,
    error: {},
    app: {},
    dashboardData: {},
    dashboardDataPpc: {},
    dashboardDataAcos: {},
    dashboardDataSpend: {},
  },
  reducers: {},
  extraReducers: {
    [getApp.pending]: (state) => {
      state.loading = true;
    },
    [getApp.fulfilled]: (state, action) => {
      state.loading = false;
      state.app = action.payload;
    },
    [getApp.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    [getDashboardData.pending]: (state) => {
      state.loading = true;
    },
    [getDashboardData.fulfilled]: (state, action) => {
      state.loading = false;
      state.dashboardData = action.payload;
      state.error = {};
    },
    [getDashboardData.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    // ppc perfomance

    [getDashboardDataPerformance.pending]: (state) => {
      state.loading = true;
    },
    [getDashboardDataPerformance.fulfilled]: (state, action) => {
      state.loading = false;
      state.dashboardDataPpc = action.payload;
      state.error = {};
    },
    [getDashboardDataPerformance.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    // acos
    [getDashboardDataHighestAcos.pending]: (state) => {
      state.loading = true;
    },
    [getDashboardDataHighestAcos.fulfilled]: (state, action) => {
      state.loading = false;
      state.dashboardDataAcos = action.payload;
      state.error = {};
    },
    [getDashboardDataHighestAcos.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    // spend
    [getDashboardDataHighestSpend.pending]: (state) => {
      state.loading = true;
    },
    [getDashboardDataHighestSpend.fulfilled]: (state, action) => {
      state.loading = false;
      state.dashboardDataSpend = action.payload;
      state.error = {};
    },
    [getDashboardDataHighestSpend.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});

export default appSlice.reducer;
